import { Instagram } from "lucide-react";

const nav = [
  { href: "#collezioni", label: "Collezioni", testid: "footer-link-collezioni" },
  { href: "#configura", label: "Configuratore", testid: "footer-link-configuratore" },
  { href: "#manifesto", label: "Chi Siamo", testid: "footer-link-chi-siamo" },
  { href: "#instagram", label: "Instagram", testid: "footer-link-instagram" },
];

export default function Footer() {
  return (
    <footer className="bg-[#37282B] text-[#FDF8F7] border-t border-[#E2A3B1]/20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-20">
        <div className="flex flex-col lg:flex-row justify-between gap-12">
          <div className="max-w-sm">
            <a href="#top" className="inline-block" data-testid="footer-logo">
              <img src="/logo.png" alt="Ma.Vi Gioielli" className="h-16 w-auto" />
            </a>
            <p className="mt-5 text-sm text-[#FDF8F7]/60 leading-relaxed">
              Gioielli artigianali personalizzati, incisi a mano in Italia.
              Pendenti con i nomi dei tuoi bambini, creati per durare per sempre.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-12 lg:gap-20">
            <div>
              <span className="text-xs uppercase tracking-[0.25em] font-semibold text-[#E2A3B1]">Esplora</span>
              <ul className="mt-5 space-y-3">
                {nav.map((l) => (
                  <li key={l.href}>
                    <a
                      href={l.href}
                      data-testid={l.testid}
                      className="text-sm text-[#FDF8F7]/70 hover:text-[#E2A3B1] transition-colors duration-300"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
                <li>
                  <a href="/admin" data-testid="footer-link-admin" className="text-sm text-[#FDF8F7]/40 hover:text-[#E2A3B1] transition-colors duration-300">
                    Area riservata
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <span className="text-xs uppercase tracking-[0.25em] font-semibold text-[#E2A3B1]">Contatti</span>
              <ul className="mt-5 space-y-3">
                <li>
                  <a
                    href="https://wa.me/393336381818"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-whatsapp-link"
                    className="text-sm text-[#FDF8F7]/70 hover:text-[#E2A3B1] transition-colors duration-300"
                  >
                    WhatsApp +39 333 6381818
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/ma.vi_gioielli"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-instagram-link"
                    className="inline-flex items-center gap-2 text-sm text-[#FDF8F7]/70 hover:text-[#E2A3B1] transition-colors duration-300"
                  >
                    <Instagram className="w-4 h-4" />
                    @ma.vi_gioielli
                  </a>
                </li>
                <li className="text-sm text-[#FDF8F7]/70">Spedizione gratuita sopra €70</li>
                <li className="text-sm text-[#FDF8F7]/70">Lavorazione in 5/10 giorni lavorativi · Spedito con corriere assicurato</li>
                <li className="text-sm text-[#FDF8F7]/70">Ogni gioiello è corredato di confezione regalo gratuita</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#FDF8F7]/10 text-center" data-testid="footer-legal">
          <p className="text-xs text-[#FDF8F7]/50 leading-relaxed">
            Ma.Vi è un brand di <span className="text-[#FDF8F7]/75 font-semibold">Arcadia Gioielli S.r.l.</span> — Via Tevere 140, 52043 Castiglion Fiorentino (AR)
            <br />
            P.IVA 02340230511 ·{" "}
            <a href="mailto:info@arcadiaoro.it" className="hover:text-[#E2A3B1] transition-colors" data-testid="footer-email-link">
              info@arcadiaoro.it
            </a>{" "}
            ·{" "}
            <a href="/privacy" className="underline underline-offset-2 hover:text-[#E2A3B1] transition-colors" data-testid="footer-privacy-link">
              Privacy Policy
            </a>
          </p>
        </div>

        <div className="mt-8 pt-8 border-t border-[#FDF8F7]/10 flex flex-col sm:flex-row justify-between gap-4">
          <p className="text-xs text-[#FDF8F7]/40" data-testid="footer-copyright">
            © 2026 Ma.Vi Gioielli — Tutti i diritti riservati. Creazioni Artigianali Italiane.
          </p>
          <p className="font-serif-display italic text-sm text-[#E2A3B1]/70">
            Fatto a mano, con amore.
          </p>
        </div>
      </div>
    </footer>
  );
}
